// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"ok_a bhc_qr bhc_a bhc_w","FaqAskQuestion__outdated":"ok_b bhc_vp bhc_xe"};